import { AnimatePresence } from 'motion/react';
import React from 'react';

import { Event } from '@/payload-types';
import { cn } from '@/utils/cn';

import { EventCard } from '../EventCard';
import styles from './EventsList.module.scss';

type Props = {
  cards: Event[];
  title?: string;
  trackingCTA?: string;
  tagsNoBackground?: boolean;
};

export const EventsList: React.FC<Props> = ({
  cards,
  tagsNoBackground,
  title,
  trackingCTA,
}) => {
  if (!cards || cards.length === 0) {
    return null;
  }

  return (
    <div className={cn('container', styles.list)}>
      {title && <h2 className={styles.title}>{title}</h2>}
      <AnimatePresence>
        {cards.map((card) => (
          <EventCard
            key={card.id}
            className={styles.card}
            tagsNoBackground={tagsNoBackground}
            tracking={{
              type: 'Events list',
              headline: trackingCTA || title || '',
              cta: card.title,
            }}
            {...card}
          />
        ))}
      </AnimatePresence>
    </div>
  );
};
